module.exports = __webpack_public_path__ + "img/c-icon.d3a6e1af.png";